import {MeshLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshLocation';
import {MeshLocationUtils} from '@mintdata-wsp/common/util/MeshLocationUtils';
import {custom, optional, serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';
import {observable} from 'mobx';

export enum MeshRangeCardinality
{
    Cells = 'Cells',
    FullRows = 'FullRows',
    FullColumns = 'FullColumns',
    FullTable = 'FullTable'
}

const meshLocationModelSchema = custom(
    function(currentPropertyValue:MeshLocation)
    {
        return currentPropertyValue.toJson();
    },
    function(jsonValue:any, context?, currentPropertyValue?)
    {
        return new MeshLocation(jsonValue.colIndex, jsonValue.rowIndex);
    },
);

export class MeshRange
{
    @observable
    @serializable(optional(meshLocationModelSchema))
    public readonly from:MeshLocation = null;
    @observable
    @serializable(optional(meshLocationModelSchema))
    public readonly to:MeshLocation = null;

    public constructor(from:MeshLocation = null, to:MeshLocation = null)
    {
        this.from = from;
        this.to = to;
    }

    public get isSingleCell():boolean
    {
        return this.from && this.to && this.from.isEqualTo(this.to);
    }

    public get columnsCount():number
    {
        return (this.to || this.from).colIndex - this.from.colIndex + 1;
    }

    public get rowsCount():number
    {
        return (this.to || this.from).rowIndex - this.from.rowIndex + 1;
    }

    public get columnsRangeString():string
    {
        return `${MeshLocationUtils.getLetterByColumnIndex(
            this.from.colIndex
        )}-${MeshLocationUtils.getLetterByColumnIndex(
            (this.to || this.from).colIndex
        )}`;
    }

    public get rowsRangeString():string
    {
        return `${this.from.rowIndex + 1}-${(this.to || this.from).rowIndex + 1}`;
    }

    public asKey():string
    {
        if( this.from && this.to )
            return `${this.from.asKey()}:${this.to.asKey()}`;

        return null;
    }

    public isEqualTo(other:MeshRange):boolean
    {
        return other && this.asKey() === other.asKey();
    }

    public static ofEntireSheet():MeshRange
    {
        return new MeshRange(
            new MeshLocation(null, null),
            new MeshLocation(null, null)
        );
    }

    public static ofEntireRow(rowIndex:number):MeshRange
    {
        return new MeshRange(
            new MeshLocation(null, rowIndex),
            new MeshLocation(null, rowIndex)
        );
    }

    public static ofEntireCol(colIndex:number):MeshRange
    {
        return new MeshRange(
            new MeshLocation(colIndex, null),
            new MeshLocation(colIndex, null)
        );
    }
}

// export class MeshRange
// {
//     @observable public readonly from:MeshLocation = null;
//     @observable public readonly to:MeshLocation = null;
//
//     public constructor(from:MeshLocation = null, to:MeshLocation = null)
//     {
//         this.from = from;
//         this.to = to;
//     }
//
//     @computed
//     public get isSingleCell():boolean
//     {
//         return this.from && this.to && this.from.isEqualTo(this.to);
//     }
//
//     @computed
//     public get columnsCount():number
//     {
//         return (this.to || this.from).colIndex - this.from.colIndex + 1;
//     }
//
//     @computed
//     public get rowsCount():number
//     {
//         return (this.to || this.from).rowIndex - this.from.rowIndex + 1;
//     }
//
//     @computed
//     public get columnsRangeString():string
//     {
//         return `${MeshLocationUtils.getLetterByColumnIndex(
//             this.from.colIndex
//         )}-${MeshLocationUtils.getLetterByColumnIndex(
//             (this.to || this.from).colIndex
//         )}`;
//     }
//
//     @computed
//     public get rowsRangeString():string
//     {
//         return `${this.from.rowIndex + 1}-${(this.to || this.from).rowIndex + 1}`;
//     }
//
//     public asKey():string
//     {
//         if( this.from && this.to )
//             return `${this.from.asKey()}:${this.to.asKey()}`;
//
//         return null;
//     }
//
//     public isEqualTo(other:MeshRange):boolean
//     {
//         return other && this.asKey() === other.asKey();
//     }
// }

export class ReferencedRange extends MeshRange
{
    public readonly color:string;
    public readonly sheetName:string;

    public constructor(from:MeshLocation = null, to:MeshLocation = null, color:string = null, sheetName:string = null)
    {
        super(from, to);

        this.color = color;
        this.sheetName = sheetName;
    }
}

// export class ReferencedRange extends MeshRange
// {
//     @observable public readonly color:string = null;
//
//     public constructor(from:MeshLocation = null, to:MeshLocation = null, color:string = null)
//     {
//         super(from, to);
//
//         this.color = color;
//     }
// }
